import { useTranslation } from 'react-i18next';
import useEvents from 'lib/hooks/useEvents';
import tapEvent from 'lib/Tracking/Vdp/WarrantyPromo/TapEvent';
import VdpEventContext from 'contexts/VdpEventContext';
import { useContext } from 'react';
import styles from './styles';

const warrantyLink =
  'https://www.consumeraffairstrk.com/DFBHL/2CTPL/?sub1=SUBID&sub5=UNIQUETRANSACTIONID';

const WarrantyPromo = (): JSX.Element => {
  const { t } = useTranslation();
  const logger = useEvents();
  const { trackingParams } = useContext(VdpEventContext);

  return (
    <a
      href={warrantyLink}
      target="_blank"
      aria-label={t('accessibility.newWindow')}
      onClick={(): void => {
        logger.log(tapEvent({ trackingParams }));
      }}
      className="warranty-promo"
    >
      <div className="warranty-icon" />
      <div className="flex-container">
        <div className="warranty-text mobile">{t('vdp.warrantyPromoTextMobile')}</div>
        <div className="warranty-text desktop">{t('vdp.warrantyPromoTextDesktop')}</div>

        <div className="warranty-subtext">{t('vdp.warrantyPromoSubtext')}</div>
      </div>
      <div className="arrow-right" />
      <div className="see-rates-button">{t('vdp.seeRates')}</div>
      <style jsx>{styles}</style>
    </a>
  );
};

export default WarrantyPromo;
